<div class="mb-12 pt-5">
    @if(!item) {
        <p-message severity="error" icon="pi pi-times-circle" text="Item is not in your shopping list or deleted" styleClass="h-full mb-3" />
    }

    <form [formGroup]="itemForm" class="flex flex-col gap-4">
        <p-iftalabel>
            <input pInputText id="name" formControlName="name"/>
            <label for="name">Item Name</label>
        </p-iftalabel>

        <p-iftalabel>
            <input pInputText id="quantity" formControlName="quantity"/>
            <label for="quantity">Quantity</label>
        </p-iftalabel>
            
        <p-iftalabel>
            <p-autocomplete id="store" formControlName="store" [dropdown]="storeSuggestions.length > 0" [suggestions]="storeSuggestions" (completeMethod)="searchStore($event)" />
            <label for="store">Store Name</label>
        </p-iftalabel>

        <p-iftalabel>
            <input pInputText id="location" formControlName="location"/>
            <label for="location">Store Location</label>
        </p-iftalabel>
        <p-iftalabel>
            <textarea si pTextarea rows="2" [autoResize]="true" pInputText id="location" formControlName="notes"
            placeholder="You could add your generic thought process while you shop this item including ingredients to avoid"></textarea>
            <label for="location">Notes</label>
        </p-iftalabel>

        <div class="flex flex-col gap-2">
            <label style="color: #71717a; font-size: .75rem;" >Images</label>
            @if (!utilityService.cameraPermissionStatus?.granted) {
                <p-message severity="warn" [size]="'small'">Need camera permission to capture photo and upload. &nbsp;<a style="text-decoration: underline; color:#a16207; cursor: pointer;" (click)="requestCameraPermission()">Grant Permission</a></p-message>
            }
            @if((item?.images || []).length <= 3) {
                <p-fileupload 
                    #fileupload 
                    class="flex" mode="basic" name="image" chooseIcon="pi pi-upload" 
                    [customUpload]="true" 
                    [multiple]="true" 
                    accept="image/*" 
                    capture="environment"
                    [disabled]="readOnly || uploadingImagesInProgress"
                    (uploadHandler)="uploadImage($event, fileupload)" 
                    [auto]="true" chooseLabel="Upload" />
            }
            <div class="flex flex-wrap gap-2 my-2">
                @for (image of item?.images; track $index) {
                    <p-image [imageStyle]="{'border-radius': '8px'}" [src]="image.downloadUrl" alt="Image" width="150" [preview]="true" />
                }
                @if(uploadingImagesInProgress) {
                    <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration="1s" [style]="{ width: '30px', height: '30px' }" />
                }

            </div>
            
        </div>
    </form>
</div>
@if(!readOnly) {
    <div class="absolute bottom-0 left-0 right-0 w-full p-2 flex justify-center">
        <p-button 
        [style]="{background: '#4D7935'}"
         class="w-full [&_button]:w-full [&_button]:bg-green-100 [&_button]:border-0 [&_button]:text-white" 
         type="button" 
         label="Save" 
         (click)="save()" 
         [disabled]="!itemForm.dirty || !itemForm.valid"
         [loading]="saving"/>
    </div>
}

